'use client';

// The global Toaster is mounted in src/app/layout.tsx.
// This compatibility component avoids duplicate notification containers.
export default function ToastProvider() {
  return null;
}
